const NotificationBellIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_279_3782"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_279_3782)">
        <mask
          id="mask1_279_3782"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask1_279_3782)">
          <path
            d="M3.5 12.59C3.35833 12.59 3.23961 12.5421 3.14383 12.4463C3.04794 12.3504 3 12.2316 3 12.0898C3 11.9482 3.04794 11.8294 3.14383 11.7337C3.23961 11.638 3.35833 11.5902 3.5 11.5902H4.20517V6.61566C4.20517 5.7191 4.48189 4.92638 5.03533 4.23749C5.58867 3.5486 6.29911 3.10799 7.16667 2.91566V2.50033C7.16667 2.26888 7.24761 2.0721 7.4095 1.90999C7.57139 1.74799 7.76794 1.66699 7.99917 1.66699C8.2305 1.66699 8.42733 1.74799 8.58967 1.90999C8.75211 2.0721 8.83333 2.26888 8.83333 2.50033V2.91566C9.70089 3.10799 10.4113 3.5486 10.9647 4.23749C11.5181 4.92638 11.7948 5.7191 11.7948 6.61566V11.5902H12.5C12.6417 11.5902 12.7604 11.638 12.8562 11.7338C12.9521 11.8297 13 11.9485 13 12.0903C13 12.232 12.9521 12.3507 12.8562 12.4465C12.7604 12.5422 12.6417 12.59 12.5 12.59H3.5ZM7.99883 14.4618C7.66717 14.4618 7.38361 14.3438 7.14817 14.1078C6.91261 13.8718 6.79483 13.5881 6.79483 13.2567H9.20517C9.20517 13.5892 9.08706 13.8732 8.85083 14.1087C8.61461 14.3441 8.33061 14.4618 7.99883 14.4618ZM5.20517 11.5902H10.7948V6.61566C10.7948 5.84388 10.522 5.18516 9.97633 4.63949C9.43056 4.09371 8.77178 3.82083 8 3.82083C7.22822 3.82083 6.56944 4.09371 6.02367 4.63949C5.478 5.18516 5.20517 5.84388 5.20517 6.61566V11.5902Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
    </svg>
  );
};

export default NotificationBellIcon;
